<template>
  <div class="loginbody">
    <img src="@/assets/dllogo2.png" style="width: 240px;" />

    <div class="box">

      <div class="box-left">
        <h2 style="font-weight: 700;margin-bottom: -10px;">供应商平台</h2>
        <img src="./loginLO.svg" alt="" style="width: 460px; margin-top: 10px;">
        <!-- <img src="./loginImg1.png" alt="" style="width: 240px; margin-top: 10px;"> -->
      </div>


      <div class="content">
        <div class="content-input">
          <div class="welcome">用户登录</div>
          <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
            label-position="left">
            <el-form-item prop="username">
              <el-input @keyup.enter.native="handleLogin" placeholder="请输入登陆ID" name="username" type="text"
                v-model="loginForm.username" autoComplete="on">
                <i slot="prefix" class="el-input__icon el-icon-user" style="color:rgba(11,161,248,1);font-size: 20px;">
                  <span class="incosolid"></span>
                </i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input @keyup.enter.native="handleLogin" name="password" :type="pwdType" v-model="loginForm.password"
                placeholder="请输入密码" autoComplete="on" show-password>
                <i slot="prefix" class="el-input__icon el-icon-lock" style="color:rgba(11,161,248,1);font-size: 20px;">
                  <span class="incosolid"></span>
                </i>
              </el-input>
            </el-form-item>
            <div style="display: flex;justify-content:space-between;	align-items: center; margin-bottom: 50px;">
              <el-checkbox style="color: #000;" v-model="loginForm.checked" @change="rmbpassword">记住密码</el-checkbox>
            </div>
            <div class="tips" v-if="isIdentityAuth">
              <router-link to="/oidcRedirect">
                <el-badge is-dot>接口服务器启用了Oauth认证，请点击这里登录</el-badge>
              </router-link>
            </div>
            <el-form-item>
              <el-button style="border-radius: 60px;" v-waves type="primary" class="loginbtn" :loading="loading"
                @click.native.prevent="handleLogin">
                登 录
              </el-button>
            </el-form-item>
            <el-form-item>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import waves from '@/directive/waves' // 水波纹指令
import identify from '@/components/ImgVerify'
import { List } from '@/utils/comReqest'

import {
  mapGetters,
  mapActions
} from 'vuex'
export default {
  name: 'login',
  components: {
    identify
  },
  directives: {
    waves
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('用户名不能为空'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    const validcode = (rule, value, callback) => {
      console.log('value', value)
      // if (!value) {
      //   callback(new Error('验证码不能为空'))
      // } else if (value.toLowerCase() !== this.identifyCode.toLowerCase()) {
      //   callback(new Error('验证码不正确'))
      // } else {
      //   callback()
      // }
    }
    return {
      tenant: this.tenantid || 'OpenAuthDBContext', //当前选择的租户
      tenants: [{
        value: 'OpenAuthDBContext',
        label: '默认租户'
      }, {
        value: 'ErrorId404',
        label: '模拟一个不存在的租户'
      }],
      loginForm: {
        username: '',
        password: '',
        code: '',
        checked: false
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePass
        }],
        code: [{
          required: true,
          trigger: 'blur',
          validator: validcode
        }]
      },
      loading: false,
      pwdType: 'password',
      identifyCode: ''
    }
  },
  created() {

    // 在页面加载时从cookie获取登录信息

    // debugger

    let password = this.getCookie("password");
    let userName = this.getCookie("username");
    let checked = this.getCookie('checked')
    console.log(userName, password, checked);
    // 如果存在赋值给表单，并且将记住密码勾选


    if (checked) {
      this.loginForm.username = userName;
      this.loginForm.password = password;
      this.loginForm.checked = true;
    }
    console.log(this.loginForm);
  },

  methods: {
    ...mapActions([
      'setTenantId', //
    ]),

    tenantChange(e) {
      this.setTenantId(e)
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    continueLogin(res) {
      if (res.returnUrl) {
        window.localStorage.setItem('returnUrl', JSON.stringify(res.returnUrl))
      }

      if (res.org) {
        const dept = res.org.filter(x => x.deptCode)
        if (Array.isArray(res.org) && res.org.length > 1 && dept && dept.length > 1) {
          console.log('[Login] 多部门 → /orginfo')
          this.$router.push({ path: '/orginfo' })
        } else {
          const url = JSON.parse(window.localStorage.getItem('returnUrl'))
          console.log('[Login] 单部门/无部门 → 跳转:', url || '/')
          this.$router.push({ path: url || '/' })
        }
      } else {
        const url = JSON.parse(window.localStorage.getItem('returnUrl'))
        console.log('[Login] 无 org → 跳转:', url || '/')
        this.$router.push({ path: url || '/' })
      }

      this.loading = false
    },
    handleLogin() {
      if (this.loading) {
        return
      }

      window.localStorage.removeItem('Currentdepartment')
      window.localStorage.removeItem('department')
      window.localStorage.removeItem('username')
      window.localStorage.removeItem('modules')
      window.localStorage.removeItem('routers')
      window.localStorage.clear()
      if (this.loginForm.checked) {
        this.setCookie('password', this.loginForm.password)
        this.setCookie('checked', this.loginForm.checked)
        this.setCookie('username', this.loginForm.username)
      } else {
        this.setCookie('username', this.loginForm.username)
        this.setCookie('password', '')
        this.setCookie('checked', false)
      }

      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }

        this.loading = true
        this.$store.dispatch('Login', this.loginForm).then((res) => {
          console.log('[Login] ✅ then 进入, res keys:', Object.keys(res || {}))
          console.log('[Login] token:', res.token, '| org:', res.org, '| returnUrl:', res.returnUrl)
          console.log('[Login] result字段:', res.result)

          return List({
            pagecode: 'warn_flag',
            businessid: (res.result && res.result.account) ||
              res.businessid ||
              res.businessId ||
              res.BusinessId ||
              window.localStorage.getItem('businessid') ||
              this.loginForm.username
          }).then((warnResponse) => {
            const warnData = warnResponse && (warnResponse.result || warnResponse.data || warnResponse)
            const warnFlag = Array.isArray(warnData)
              ? warnData[0] && (warnData[0].warn_flag || warnData[0].WARN_FLAG)
              : warnData && (warnData.warn_flag || warnData.WARN_FLAG)

            const shouldShowResourceWarning = String(warnFlag).toUpperCase() === 'Y'
            if (shouldShowResourceWarning) {
              console.warn('[Login] 当前账号命中 warn_flag=Y，进入业务页面后提示5分钟')
              window.localStorage.setItem(
                'resourceWarningUntil',
                String(Date.now() + 5 * 60 * 1000)
              )
            }

            this.continueLogin(res)
            if (shouldShowResourceWarning) {
              window.setTimeout(() => {
                window.dispatchEvent(new Event('resource-warning'))
              }, 0)
            }
          })
        }).catch((err) => {
          console.error('[Login] ❌ catch 触发:', err)
          this.loading = false
        })
      })
    },
    rmbpassword() {

    },
    gopathd() {

   
      let url = ''
     let boj = []
      if (JSON.parse(window.localStorage.getItem('returnUrl'))) {
        url = JSON.parse(window.localStorage.getItem('returnUrl')) || ''
      }
      if (JSON.parse(window.localStorage.getItem('routers'))) {
        boj = JSON.parse(window.localStorage.getItem('routers')) || [];
      }


      if (url.length > 0) {
        boj.forEach(x => {
          if (x.redirect == 'dashboard') {
            x.children.forEach(y => {
              if (y.path == url) {
                y.hidden = false
                console.log(y);
                window.localStorage.setItem('routers', JSON.stringify(boj))
                this.$router.push({
                  path: url
                })
              }
            })
          }
        })

      } else {
        boj.forEach(x => {
          if (x.redirect == 'dashboard') {
            x.children.forEach(y => {
              if (y.path == '/dashboard') {
                y.hidden = false
                // console.log(y);
                window.localStorage.setItem('routers', JSON.stringify(boj))
                this.$router.push({
                  path: '/'
                })
              }
            })
          }
        })
      }
    },
    // 获取cookie
    getCookie: function (key) {
      if (document.cookie.length > 0) {
        let start = document.cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          let end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    // 保存cookie
    setCookie(cName, value, expiredays) {

      let exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = cName + '=' + decodeURIComponent(value) +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    },

    // 修改验证码
    changeCode(val) {
      this.identifyCode = val
    }
  },
  computed: {
    ...mapGetters([
      'isIdentityAuth',
      'tenantid',
    ])
  },
}
</script>

<style rel="stylesheet/scss" scoped lang="scss">
::deep .el-form-item .is-required {
  margin-bottom: 30px;
}


.loginbody {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-image: url("~@/assets/bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;


  .el-input__inner {
    // background-color: rgba(11, 161, 248, 0.1) !important;
    // border: 2px rgba(11, 161, 248, 0.5) solid !important;
    border: none !important;
    color: #ffffff !important;
    // font-weight: bold !important;
  }

  .el-input__inner::placeholder {
    border: none !important;
    color: #ffffff !important;
    font-weight: 100 !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #ffffff;
  }

  .el-checkbox {
    color: #ffffff;
  }


}

.loginbody>img {
  position: fixed;
  left: 1vw;
  top: 1vw;
  width: 15vw;
  height: auto;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  // position: fixed;
  // background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 980px;
  height: 480px;
  border-radius: 20px;
  overflow: hidden;
  border: 1px rgba(11, 161, 248, 0.4) solid;

  .box-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(234, 239, 254, 1);
    border: none;
    // padding-left:50px ;
    height: 100%;
    width: 100%;
  }
}

.title {
  width: 100%;
  height: auto;
}

.content {
  width: 600px;
  background-color: rgba(255, 255, 255, 1);
  height: 100%;
  overflow: hidden;
}

.welcome {
  text-align: center;
  font-size: 18px;
  letter-spacing: 10px;
  margin-top: 40px;
  margin-bottom: 35px;
  font-weight: bold;
  color: #00bef7;
}


// .confir{
// 	/*padding: 30px;*/
// }
.btn {
  background-color: #0ba1f8;
  color: #ffffff;
  font-size: 30px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-top,
.arrow-bottom {
  display: flex;
  justify-content: space-between;
  height: 30px;
}

.arrow-top img,
.arrow-bottom img {
  height: 30px;
}

img {
  display: block;
  padding: 0;
  margin: 0;
}

.content-input {
  padding: 0 30px;
}

/* 输入相关*/
.forget,
.forget-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
}

.checkbox {
  width: 30px;
  height: 30px;
  background-color: rgba(11, 161, 248, 0.1) !important;
  border: 5px rgba(11, 161, 248, 0.5) solid !important;
  ;
}



.footer {
  margin-top: 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@media screen and (max-width: 1150px) {
  .leftImg {
    width: 450px !important;
  }
}

@media screen and (max-width: 1010px) {
  .leftImg {
    width: 380px !important;
  }
}

@media screen and (max-width: 940px) {
  .leftImg {
    display: block;
    width: 260px !important;
    margin: 0 auto !important;
  }
}

$dark_gray: #D1DFE8;

.login-container {
  height: 100%;
  background: url('~@/assets/login/bg.png') no-repeat;
  background-color: #EBEBEA;
  background-position: 0 0;
  background-size: 62% 100%;
  text-align: center;

  &:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .content {
    /* display: inline-block; */
    /* vertical-align: middle; */


    /* >img {
        width: 568px;
        margin-right: 150px;
        vertical-align: middle;
      }

      .login-form {
        display: inline-block;
        margin-left: 310px;
        margin-top: -80px;
        width: 240x;
        width: 400px;
        vertical-align: middle;
      } */
  }

  .svg-container {
    color: $dark_gray;
    vertical-align: middle;
    width: 33px;
    display: inline-block;
    font-size: 22px;

    &_login {
      font-size: 31px;
    }
  }

  .title {
    font-size: 26px;
    font-weight: 400;
    color: #4452D5;
    margin: 0;
    text-align: left;
  }

  .tips {
    color: #959595;
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 40px;
    text-align: left;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
    font-size: 24px;
  }
}

.loginbtn {
  width: 100%;
  background: #409eff;
  font-size: 16px;
  height: 40px;
  line-height: 10px;
  color: #fff;
  border-radius: 20px;
  border: none;
}

.loginbtn:hover {
  // box-shadow: 0px 1px 6px 1px #0093E9;
}

.incosolid {
  position: absolute;
  top: 12px;
  right: -10px;
  display: inline-block;
  border-right: 2px solid rgba(11, 161, 248, 1);
  height: 16px;
}
</style>
